import styled from "styled-components";

export const Root = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
`;

export const Avatar = styled.div<{ "data-image"?: string }>`
  display: flex;
  background: ${(props) => (props["data-image"] ? "transparent" : "linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)")};
  width: 22px;
  height: 22px;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 2px solid rgba(255, 255, 255, 0.15);

  &:hover {
    border-color: rgba(255, 255, 255, 0.3);
    transform: scale(1.05);
  }

  & img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
  }
`;

export const Menu = styled.div`
  display: flex;
  background: rgba(30, 30, 30, 0.98);
  min-width: 180px;
  position: absolute;
  top: calc(100% + 2px);
  right: 0px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  flex-direction: column;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
  padding: 4px;
  overflow: hidden;
  z-index: 10001;
`;

export const UserName = styled.div`
  display: flex;
  align-items: center;
  color: #e5e7eb;
  height: 24px;
  padding: 0px 8px;
  font-family: 'Roboto', monospace;
  font-size: 11px;
  background: transparent;
  font-weight: 500;
  letter-spacing: 0.5px;
  cursor: pointer;
  transition: color 0.2s ease;
  margin-right: 8px;
  justify-content: center;
  margin-top:5px;

  &:hover {
    color: #fff;
  }
`;

export const Items = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0px;
`;

export const Item = styled.div`
  width: 100%;
  color: #d1d5db;
  padding: 8px 12px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 13px;
  text-align: left;
  box-sizing: border-box;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.15s ease;
  user-select: none;

  &:hover {
    background: rgba(139, 92, 246, 0.15);
    color: #f3f4f6;
  }

  &:active {
    background: rgba(59, 130, 246, 0.2);
  }
`;
